

import React from "react";
import { Button, TableAdv } from "../../../../components";
import { dateFormator, mapTableRows } from "../../../../utils";
import { usePagination } from "../../../../hooks";

const PastPayCycles = () => {
  const { page, limit, setPage, handleLimitChange } = usePagination(
        10,
        (newPage, newLimit) => { }
      );
  const tableData = [
    {
      payCycle: "04/01/2025 - 04/30/2025",
      actualPayDate: "2025-05-12T00:00:00.000Z",
      payDate: "2025-05-12T00:00:00.000Z",
    },
    {
      payCycle: "05/01/2025 - 05/31/2025",
      actualPayDate: "2025-05-12T00:00:00.000Z",
      payDate: "2025-06-12T00:00:00.000Z",
    },
  ];
  const columns = [
    {
      key: "payCycle",
      label: "Pay Cycle",
      //   render: (row) => dateFormator(row.payCycle, "month-day-year"),
    },
    {
      key: "actualPayDate",
      label: "Actual Pay Date",
      render: (row) => dateFormator(row.actualPayDate, "month-day-year"),
    },
    {
      key: "payDate",
      label: "Pay Date",
      render: (row) => dateFormator(row.payDate, "month-day-year"),
    },
    
  ];

  const mappedRows = mapTableRows(tableData, columns);
  return (
    <div>
      <TableAdv
        tableId={`payroll_salaryprofileconfiguration_pastpaycycles`}
        rows={mappedRows}
        columns={columns}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={{
          search:true
        }}
      />
    </div>
  );
};

export default PastPayCycles;
